import styled from '@emotion/styled'

import { noneOf } from './none-of'

export const Constraint = styled('div', {
  shouldForwardProp: noneOf(['as', 'width', 'height', 'centered']),
})`
  ${props => props.width && `max-width: ${props.width}px`};
  ${props => props.height && `max-height: ${props.height}px`};
  ${props => props.centered && `margin: auto`};
`
